import { IMAGES } from "@/data/salon";
import { Overline, Reveal } from "@/components/Reveal";

const CHAPTERS = [
    {
        n: "01",
        title: "Prima di tutto, la consulenza",
        text: "Niente tagli in serie. Prima di prendere in mano le forbici ti ascoltiamo: come vivi i tuoi capelli, cosa desideri, cosa ti preoccupa. Anche solo da una foto sul telefono capiamo subito cosa è meglio per te.",
    },
    {
        n: "02",
        title: "Capelli difficili? Benvenuti",
        text: "Chiome molto lunghe, ricci impegnativi, colori da sistemare: dove altri alzano le mani, noi ci appassioniamo. Le clienti che arrivano da noi dopo un 'disastro' altrove restano per anni.",
    },
    {
        n: "03",
        title: "Una relazione che dura",
        text: "C'è chi si affida a noi da più di sei anni e non cambierebbe per nulla al mondo. È questa la nostra misura del successo: clienti che tornano, e che ci mandano le persone care.",
    },
];

const About = () => (
    <section
        id="chi-siamo"
        data-testid="about-section"
        className="py-24 md:py-32 bg-cream"
    >
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-14 lg:gap-24">
            <div>
                <div className="lg:sticky lg:top-28">
                    <Reveal>
                        <Overline>Chi Siamo</Overline>
                        <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink mt-4">
                            Un salone dove ti senti{" "}
                            <em className="italic text-sage">ascoltata</em>, non servita.
                        </h2>
                        <p className="mt-6 text-stone2 text-base md:text-lg leading-relaxed max-w-md">
                            Nel cuore di Paese, a pochi minuti da Treviso, Moovie è un
                            salone intimo e accogliente dove la cura della persona viene
                            prima di ogni tendenza. Staff competente, ambiente caldo,
                            orari rispettati.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15} className="mt-10">
                        <div className="overflow-hidden border border-linen/60">
                            <img
                                src={IMAGES.staff}
                                alt="Lo staff di Moovie Parrucchieri in salone"
                                className="w-full aspect-[4/5] object-cover object-top hover:scale-[1.03] transition-transform duration-700"
                            />
                        </div>
                        <p className="mt-3 text-xs tracking-[0.2em] uppercase text-stone2/70">
                            Il nostro staff · Via Postumia 166A, Paese
                        </p>
                    </Reveal>
                </div>
            </div>

            <div className="flex flex-col justify-center">
                {CHAPTERS.map((c, i) => (
                    <Reveal key={c.n} delay={i * 0.12}>
                        <div
                            data-testid={`about-chapter-${c.n}`}
                            className="group border-t border-linen py-10 md:py-12 first:border-t-0 first:pt-0"
                        >
                            <span className="font-serif italic text-2xl text-rosegold">
                                {c.n}
                            </span>
                            <h3 className="font-serif text-2xl md:text-4xl text-ink mt-3 leading-snug group-hover:translate-x-2 transition-transform duration-500">
                                {c.title}
                            </h3>
                            <p className="mt-4 text-stone2 leading-relaxed max-w-lg">
                                {c.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default About;
